/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccessTokenResponse } from '../models/AccessTokenResponse';
import type { LoginRequest } from '../models/LoginRequest';
import type { SimeTokeRequest } from '../models/SimeTokeRequest';
import type { TwoFactorLoginRequest } from '../models/TwoFactorLoginRequest';
import type { TwoFactorResendTokenRequest } from '../models/TwoFactorResendTokenRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LoginService {
    /**
     * Refresh token endpoint
     * @param requestBody
     * @returns AccessTokenResponse Success
     * @throws ApiError
     */
    public static userTokenService(
        requestBody: SimeTokeRequest,
    ): CancelablePromise<AccessTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/login/refresh-token',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * 2FA resend token
     * Resend token for Two-factor authentication.
     * @param requestBody
     * @returns AccessTokenResponse Success
     * @throws ApiError
     */
    public static twoFactorResendTokenEndpoint(
        requestBody: TwoFactorResendTokenRequest,
    ): CancelablePromise<AccessTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/login/2fa/resend-token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * 2FA Login
     * Login Stored user via Two-factor authenticator.
     * @param requestBody
     * @returns AccessTokenResponse Success
     * @throws ApiError
     */
    public static twoFactorLoginEndpoint(
        requestBody: TwoFactorLoginRequest,
    ): CancelablePromise<AccessTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/login/2fa',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `User is not authorized`,
            },
        });
    }
    /**
     * email/password login.
     * Authenticates an user by user email and password.
     * @param requestBody
     * @returns AccessTokenResponse Success
     * @throws ApiError
     */
    public static loginEndpoint(
        requestBody: LoginRequest,
    ): CancelablePromise<AccessTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/login/basic',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
